module.exports = __webpack_public_path__ + "static/media/slider-0.776f155c.jpg";